const swornDeclarationUrl = '/Declaración Jurada de Veracidad Información -FACILITA_12.10.23.pdf'

export { swornDeclarationUrl }
